angular.module('mtic.components.modules.c3')
.service('mapItemFactory', function(
  C3_ASSET_URL,
  EventManager,
  $log,
  $timeout,
  TIMING_CONSTANTS,
  language,
  TeacherDataService,
  ModuleFilter
) {
    var currentActiveItem = null;
    var getIconFilename = function(item_info) {

      //assessments are easy
      if (item_info.resource_type === 'assessment') {
        if (item_info.complete)
        {
          return 'assessment_complete.png';
        }
        return 'assessment.png';
      }
      if (!item_info.display)
      {
        item_info.display = {};
      }

      //get the color from item_info.display.color, fall back to "red" if it isn't defined
      var color_string = (item_info.display.color !== undefined) ? item_info.display.color : 'blue';

      var suffix;
      if (item_info.locked) {
        suffix = "_locked";
      } else {
        if (!item_info.resourceState || !item_info.resourceState.complete) {
          suffix = "_0"
        } else {

          var count = 0;

          if (item_info.resourceState.score_max >= 1)
          {
            count = 3;
          } else if (item_info.resourceState.score_max >= 0.8)
          {
            count = 2;
          } else if (item_info.resourceState.score_max >= 0.5)
          {
            count = 1;
          }
          if (color_string === 'blue') {
            count = 1//Math.min(count, 1);
          }
          count = Math.max(0, count);
          suffix = "_" + count;

        }
      }
      var filename = "item_" + color_string + suffix + ".png";
      return filename;
    };
    return {
      getCurrentActiveItem: function() {
        return currentActiveItem;
      },
      createMapItem: function MapItem(item_info,onItemClick, eventManager) {

        // Grab Relevant data for item
        this.slug = item_info.slug;
        this.id = item_info.id;
        this.type = item_info.resource_type;
        this.studentWork = item_info.studentWork;
        this.container = item_info.content.container;
        this.complete = item_info.complete;
        this.locked = item_info.locked;
        this.unlocked_by = item_info.unlocked_by;
        this.content = item_info.content;
        this.verletBody = null;
        this.parentItem = null;
        var sprite, icon,agenda_highlight=null;
        var startClickPos = {
          x: 0,
          y: 0
        };

        this.setDelegate = function(del) {
          var boundClick = (function(e) {
            del(this.slug);
          }).bind(this);
          sprite.on('pointertap', boundClick)
            //sprite.on('click', );
        }

        this.selection_graphic=null;
        this.highlight_graphic=null;
        var is_item_selected;
        this.showAgendaHighlight = function(force, is_selection) {
          var radius =  this.type === 'assessment' ? 70 : 32;
          if(this.highlight_graphic===null && is_selection){
            // $log.log('show agenda highlight', this.slug, is_selection)
            this.highlight_graphic = new PIXI.Graphics();
            this.highlight_graphic.lineStyle(14, 0x33CCFF,1)
            this.highlight_graphic.drawCircle(0, 0, radius)
            this.highlight_graphic.interactive = false;
            //this.highlight_graphic.scale.set(0.75*scale,0.75*scale);
            this.highlight_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);
            icon.addChildAt(this.highlight_graphic, 0);
          }else if (!is_selection && this.selection_graphic === null && force !== false){
            // $log.log('show agenda selection', this.slug, is_selection)
            is_item_selected = is_selection;
            this.selection_graphic = new PIXI.Graphics();
            this.selection_graphic.lineStyle(8, 0xFFCC00,1)
            this.selection_graphic.drawCircle(0, 0, radius)
            this.selection_graphic.interactive = false;
            //this.selection_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);
            icon.addChild(this.selection_graphic);
          }else if(!force){
            // $log.log('from toggle agenda selection', this.slug, is_selection)
            this.hideAgendaHighlight();
          }

          // if (agenda_highlight === null)
          // {
          //   agenda_highlight = new PIXI.Graphics();
          //   agenda_highlight.lineStyle(12, 0x33CCFF);
          //   agenda_highlight.drawCircle(0,0, 32);
          //   icon.addChild(agenda_highlight);
          // }else if(!force){
          //   this.hideAgendaHighlight();
          // }
        }

        this.hideAgendaHighlight = function(from_item_highlight) {
          // $log.log('hide agenda highlight', this.slug, from_item_highlight)
          if(from_item_highlight && this.highlight_graphic !== null){
            icon.removeChild(this.highlight_graphic);
            this.highlight_graphic = null;
          }if (!from_item_highlight && this.selection_graphic !== null){
            icon.removeChild(this.selection_graphic);
            this.selection_graphic = null;
          }
        }

        var getItemDisplayName = function() {
          var itemDisplayName;
          if(item_info.display && item_info.display.nameLangId) {
            itemDisplayName = language.get(item_info.display.nameLangId)
          }else{
            itemDisplayName = language.get(item_info.slug, null, true)
          }
          if (!itemDisplayName) {
            itemDisplayName = item_info.name;
          }
          return itemDisplayName;
        }

        this.updateIcon = function() {
          // console.log(C3_ASSET_URL + getIconFilename(item_info));
          icon.texture = PIXI.loader.resources[C3_ASSET_URL + getIconFilename(item_info)].texture;
          if (item_info.resource_type === 'assessment') {
            icon.width = icon.height = 206;
          } else {
            icon.width = icon.height = 104;
          }
        }
        this.buildTooltip = function() {
          if (tooltip !== null && tooltip !== undefined) {
            sprite.removeChild(tooltip);
            tooltip.interactive = false;
          }
          tooltip = new PIXI.Sprite();

          // Text Information
          var textInfo = new PIXI.Text(getItemDisplayName(), {
            fontFamily: 'Arial',
            align: 'center',
            fontSize: 24,
            fill: 0xFFFFFF,
            dropShadow: true,
            dropShadowDistance: 1,
            dropShadowBlur: 0,
            wordWrap: true,
            wordWrapWidth: 200
          });

          var tooltip_graphics = new PIXI.Graphics();

          var drawTooltipContainer = function() {
            tooltip_graphics.clear();
            // Draw Text Bubble that wraps around the text
            tooltip_graphics.lineStyle(0);
            tooltip_graphics.beginFill(0x3B5763);
            tooltip_graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 20, 10);
            tooltip_graphics.endFill();

            // Draw Triangle pointing to planet
            tooltip_graphics.beginFill(0x3B5763);
            tooltip_graphics.moveTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2), textInfo.y - 18);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2) + 5, textInfo.y - 10);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
            tooltip_graphics.endFill();
            tooltip_graphics.x = -tooltip_graphics.width / 2 + 20;
            tooltip_graphics.y = icon.height / 2 + 10;
          }

          drawTooltipContainer();

          tooltip.addChild(tooltip_graphics);
          tooltip_graphics.addChild(textInfo);
          sprite.addChild(tooltip);
          tooltip.interactiveChildren = false;
          tooltip.visible = false;

          eventManager.listen('language:change', function() {
            if (textInfo === undefined) {
              return;
            }
            textInfo.setText(getItemDisplayName());
            drawTooltipContainer();
          })
        }

        var unclickableTypes = ['symlink']
        this.onButtonClick = function() {
          if (unclickableTypes.indexOf(this.type) > -1)
          {
            return;
          }

          //Cancel click events if they dragged more than 100 pixels
          var curPos = sprite.toGlobal(new PIXI.Point(0, 0));
          if (Math.pow(startClickPos.x - curPos.x, 2) + Math.pow(startClickPos.y - curPos.y, 2) > 100 * 100) {
            return;
          }

          $log.debug('[[mapItemFactory]] clicking on', item_info, 'LOCK STATUS:::::::::::::', this.locked);
          if ( ['mtic_g78_m1_diag', 'mtic_g78_m2_diag'].indexOf(item_info.slug) > -1 ) {
            this.locked = true;
          }
          if(!ModuleFilter.checkAvailable(item_info)){
            this.locked = true;
            item_info.locked = true;
            eventManager.broadcast('display-maintenance-message', item_info.slug);
            return;
          }
          //console.log('TeacherDataService.isTeacherModuleView', TeacherDataService.isTeacherModuleView);
          if (!this.locked || TeacherDataService.isTeacherModuleView) {
          var currentItem = this;
            $timeout(function() {
              eventManager.broadcast('module:select:resource', item_info)
              if(onItemClick){
                //onItemClick(item_info,currentItem);
                //console.log(item_info);
              }else{
                sprite.scale.set(1, 1);
                currentActiveItem = this;
                eventManager.broadcast('module:open:resource', item_info);
              }
            }, TIMING_CONSTANTS.INSTANT)
          }
        };

        this.unlock = function() {
          this.locked = false;
          item_info.locked = false;
          this.updateIcon();
        };

        this.getItemInfo = function() {
          return item_info;
        }

        this.setItemComplete = function() {
          if (this.studentWork) {
            this.studentWork.completions++;
          } else {
            this.studentWork = {
              completions: 1,
            };
          }
        }

        //For setting up verlet links to items inside a folder
        //items in minimized folders should verlet links to their parent
        this.getLinkedBody = function() {
          if (this.shouldBeOnMap()) {
            return this.verletBody;
          } else {
            return this.parentItem.getLinkedBody();
          }
        }

        //Map items inside mimized folder items get ignored
        this.shouldBeOnMap = function() {
          if (this.parentItem !== null) {
            return this.parentItem.isExpanded;
          } else {
            return this.isExpanded === true ? false : true;
          }
        }

        this.showHighlight = function() {
          if (this.type === 'symlink')
          {
            return;
          }
          if (tooltip) {
            tooltip.visible = true;
          }
          sprite.scale.set(1.1, 1.1);
          if (sprite.parent !== null) {
            sprite.parent.setChildIndex(sprite, sprite.parent.children.length - 1);
          }
        }

        this.hideHighlight = function() {
          if (tooltip) {
            tooltip.visible = false;
          }
          sprite.scale.set(1, 1);
        }

        this.pointerdown = function() {
            sprite.scale.set(0.9, 0.9);
            startClickPos = sprite.toGlobal(new PIXI.Point(0, 0));
          }
          /**
           * Tooltip setup
           */
        var tooltip;

        icon = new PIXI.Sprite();
        icon.anchor.set(0.5, 0.5);
        sprite = new PIXI.Sprite();
        this.sprite = sprite;

        var mouseOver = this.showHighlight.bind(this);
        sprite.on('mouseover', function() {
          mouseOver();
        });

        var mouseOut = this.hideHighlight.bind(this);
        sprite.on('pointerout', function() {
          mouseOut();
        });

        var pointerdown = this.pointerdown.bind(this);
        sprite.on('pointerdown', function() {
          pointerdown();
        });

        if (item_info.resource_type !== "group") {
          var boundClick = this.onButtonClick.bind(this);
          sprite.on('pointertap', boundClick);
        } else if (item_info.resource_type !== 'symlink'){
          this.open = false;
        }

        this.updateIcon();
        if (this.type === "group") {
          var bg = new PIXI.Sprite(icon.texture);
          bg.width += 20;
          bg.height += 20;

          bg.anchor.set(0.5, 0.5);
          sprite.addChild(bg);
        }
        sprite.addChild(icon);


        if (item_info.display.position !== undefined) {
          sprite.position.set(item_info.display.position.x * 2 + 120 - (icon.texture.width*1.405) / 2, item_info.display.position.y * 2 + 120 - (icon.texture.height*1.405) / 2);
        } else {
          sprite.position.set(0, 0);
        }
        sprite.interactive = true;
        sprite.buttonMode = true;
        this.buildTooltip();

        var updateItemInfoComplete = function(existsItem){
          var exists_score_max = item_info.resourceState ? item_info.resourceState.score_max : null;
          item_info.complete = existsItem.completed;
          item_info.resourceState = {complete:existsItem.completed};
          item_info.resourceState.score_max =  exists_score_max ? Math.max(exists_score_max, existsItem.score) : existsItem.score;
          item_info.score = item_info.resourceState.score_max;
        }

        eventManager.listen("teacherStudentWorkspace:studentFilter:change",function(e,eventData){
          var filteredList = eventData.list||[];
          var doneItemsList = [];
          if(filteredList  && filteredList.length>0){
            doneItemsList = _.filter(filteredList,function(item){
              return item.resource_id === item_info.id;
            });
          }

          if(doneItemsList.length > 0){ 
            var exists_info = {score: null, completed: false}
            _.each(doneItemsList, function(existsItem){
              exists_info.completed = exists_info.completed || existsItem.completed
              exists_info.score = exists_info.score ? Math.max(exists_info.score, existsItem.score) : existsItem.score;
            })
            updateItemInfoComplete(exists_info);
          }else{
            item_info.complete = false;
            item_info.resourceState = {complete:false, score_max: null};
            item_info.score = null;
          }
          if (item_info.resource_type === 'symlink') {
            icon.texture = PIXI.loader.resources[C3_ASSET_URL + "symlink.png"].texture;
          }else if(PIXI.loader.resources[C3_ASSET_URL + getIconFilename(item_info)]){
            icon.texture = PIXI.loader.resources[C3_ASSET_URL + getIconFilename(item_info)].texture;
          }
        });
      }
    }
  });
